<template>
  <div>
    <loading-overlay />
    <router-view />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import { useGuard } from '@this-dot/vue-route-guard';
import {useRoute, useRouter} from 'vue-router'

import {useAppStore} from "@/store/app";
import {initI18n, initTheme, initChat} from "@/app/utils/init";
import getPath from "@/app/utils/path";

import LoadingOverlay from "@/components/LoadingOverlay.vue";
const router = useRouter()
const route = useRoute()
const appStore = useAppStore()
const auth = useGuard()

onMounted(() => {

  // Pages like /auth/magic-link and /auth/server-login should not be redirected away
  const currentPath = getPath();
  const isSpecialAuthPage = /^\/auth\/(magic-link|server-login)/.test(currentPath);
  const pathPattern = /^\/auth/;

  const path = (pathPattern.test(currentPath) && !isSpecialAuthPage) ? "/" : currentPath

  appStore.setRedirect(path)

  appStore.setLoading(true)
  auth.refreshAuthentication()
    .then(() => {
      if (!auth.isAuthenticated() && !isSpecialAuthPage) {
        router.push({path: '/auth/login'})
      }
      if (!route.meta.requiresAuth && !isSpecialAuthPage) {
        const params = appStore.getRedirect.includes("?")
          ? Object.fromEntries(new URLSearchParams(appStore.getRedirect.split("?")[1]).entries())
          : {};
        router.push({path: appStore.getRedirect, query: params})
      }
    })
    .catch(() => {
      if (!isSpecialAuthPage) {
        router.push({path: '/auth/login'})
      }
    }).finally(() => {
      appStore.setLoading(false)
    });
  initTheme()
  initI18n()
  initChat()
})
</script>
